import React from 'react'
import styled from 'styled-components'
import { skills } from '../../data/constants'
import { RoughBox, RoughUnderline, RoughCircle } from '../common/Rough'
import { ChalkDoodles } from '../common/Doodles'

const Container = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
position: relative;
z-index: 1;
align-items: center;
padding: 40px 16px;
`

const Wrapper = styled.div`
position: relative;
display: flex;
justify-content: space-between;
align-items: center;
flex-direction: column;
width: 100%;
max-width: 1100px;
gap: 12px;
@media (max-width: 960px) {
    flex-direction: column;
}
`

export const Title = styled.div`
font-family: 'Caveat', cursive;
font-size: 52px;
text-align: center;
font-weight: 700;
margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
margin-top: 12px;
      font-size: 40px;
  }
`;

const TitleUnderline = styled.div`
  width: 140px;
  margin: -8px auto 0 auto;
`;

const SkillsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  gap: 30px;
  justify-content: center;
`

const Skill = styled.div`
  width: 100%;
  max-width: 460px;
  transform: rotate(${(p) => (p.$flip ? '-0.6deg' : '0.6deg')});
  @media (max-width: 768px) {
    max-width: 400px;
  }
  @media (max-width: 500px) {
    max-width: 330px;
  }
`;

const SkillTitle = styled.h2`
  font-family: 'Caveat', cursive;
  font-size: 30px;
  font-weight: 700;
  color: ${({ theme }) => theme.primary};
  margin-bottom: 16px;
  text-align: center;
`

const SkillList = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 4px;
`

const SkillItem = styled.div`
  font-family: 'Kalam', cursive;
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme }) => theme.text_primary};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  @media (max-width: 768px) {
    font-size: 13px;
  }
`

const SkillImage = styled.img`
  width: 18px;
  height: 18px;
  background: #fff;
  border-radius: 50%;
  padding: 2px;
  box-sizing: content-box;
`

const Bullet = styled.span`
  color: ${({ theme }) => theme.primary};
  font-size: 18px;
`


const Skills = () => {
  return (
    <Container id="skills">
      <ChalkDoodles seedBase={7} count={7} />
      <Wrapper>
        <Title>Skills</Title>
        <TitleUnderline>
          <RoughUnderline height={16} strokeWidth={3.5} />
        </TitleUnderline>
        <SkillsContainer>
          {skills.map((skill, index) => (
            <Skill key={skill.title} $flip={index % 2 === 0}>
              <RoughBox roughness={2.2} strokeWidth={1.8} padding="20px 28px" seed={index * 37 + 3}>
                <SkillTitle>{skill.title}</SkillTitle>
                <SkillList>
                  {skill.skills.map((item) => (
                    <SkillItem key={item.name}>
                      {item.image ? (
                        <RoughCircle size={30} strokeWidth={1.3} roughness={2.3}>
                          <SkillImage src={item.image} />
                        </RoughCircle>
                      ) : (
                        <Bullet>✎</Bullet>
                      )}
                      {item.name}
                    </SkillItem>
                  ))}
                </SkillList>
              </RoughBox>
            </Skill>
          ))}

        </SkillsContainer>
      </Wrapper>
    </Container>
  )
}

export default Skills
